function parseParams(textValue, paramObject) {
  return Object.keys(paramObject).reduce(
    (text, key) => text.replace(new RegExp(`\\\${${key}}`, "g"), paramObject[key]),
    textValue
  );
}
export {
  parseParams
};
